var baseStyle = {
  paddingX: 32,
  paddingBottom: 32,
  paddingTop: 24
};
export default {
  baseStyle: baseStyle
};